import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CCard, CCardBody, CCardHeader, CBadge, CCollapse } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilLightbulb, cilChevronBottom, cilChevronTop } from "@coreui/icons";

const SEVERITY_META = {
  danger: { color: "danger", label: "Критично" },
  warning: { color: "warning", label: "Внимание" },
  info: { color: "info", label: "Инфо" },
  success: { color: "success", label: "Хорошо" },
};

export default function InsightsPanel({
  insights = [],
  title = "Умные подсказки",
  defaultOpen = false,
  className = "",
}) {
  const [open, setOpen] = useState(defaultOpen);

  if (!insights.length) return null;

  const counts = insights.reduce((acc, i) => {
    acc[i.severity] = (acc[i.severity] || 0) + 1;
    return acc;
  }, {});

  return (
    <CCard className={`mb-4 insights-panel ${className}`.trim()}>
      <CCardHeader
        className="d-flex align-items-center justify-content-between py-2 insights-panel__header"
        role="button"
        onClick={() => setOpen((v) => !v)}
      >
        <div className="d-flex align-items-center gap-2">
          <CIcon icon={cilLightbulb} className="text-warning" />
          <span className="fw-semibold">{title}</span>
          <CBadge color="secondary">{insights.length}</CBadge>
          {counts.danger > 0 && <CBadge color="danger">{counts.danger}</CBadge>}
          {counts.warning > 0 && <CBadge color="warning" textColor="dark">{counts.warning}</CBadge>}
        </div>
        <CIcon icon={open ? cilChevronTop : cilChevronBottom} />
      </CCardHeader>
      <CCollapse visible={open}>
        <CCardBody className="pt-2 pb-2">
          <ul className="list-unstyled mb-0 insights-panel__list">
            {insights.map((item) => {
              const meta = SEVERITY_META[item.severity] || SEVERITY_META.info;
              return (
                <li
                  key={item.id}
                  className={`insights-panel__item insights-panel__item--${item.severity} border-start border-3 ps-3 py-2 mb-2`}
                >
                  <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                    <CBadge color={meta.color}>{meta.label}</CBadge>
                    <span className="fw-semibold small">{item.title}</span>
                  </div>
                  <p className="small text-body-secondary mb-1">{item.message}</p>
                  {item.link && (
                    <Link to={item.link} className="small">
                      {item.linkLabel || "Подробнее"} →
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </CCardBody>
      </CCollapse>
    </CCard>
  );
}
